import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { brandColors } from "../../theme";

export const arrowProgressBarStyles = (theme: Theme) =>
    createStyles({
        clearfixAfter: {
            clear: 'both',
            content: '',
            display: 'block',
            height: 10,
        },
        containerArrowProgressbar: {
            fontFamily: "'Lato', sans-serif",
            width: '100%',
            margin: '0 auto',
        },
        wrapper: {
            display: 'table-cell',
            height: '80px',
            verticalAlign: 'middle',
            paddingLeft: "0",
        },
        arrowSteps: {
            display: 'flex',
            justifyContent: 'space-between',
            '& .step': {
                fontSize: '16px',
                textAlign: 'center',
                color: '#666',
                cursor: 'default',
                margin: '0 3px',
                padding: '25px 10px 10px 30px',
                minWidth: '250px',
                position: 'relative',
                backgroundColor: '#d9e3f7',
                userSelect: 'none',
                '&:after, &:before': {
                    content: '" "',
                    position: 'absolute',
                    top: '0',
                    width: 0,
                    height: 0,
                    right: '-16px',
                    borderTop: '19px solid transparent',
                    borderBottom: '17px solid transparent',
                    borderLeft: '17px solid #d9e3f7',
                    zIndex: 2,
                    transition: 'border-color 0.2s ease',
                },
                '&:before': {
                    left: 0,
                    borderLeft: '17px solid #fff',
                    zIndex: 0,
                },
                '&:first-child:before': {
                    border: 'none',
                },
                '&:first-child': {
                    borderTopLeftRadius: '4px',
                    borderBottomLeftRadius: '4px',
                },
                '& span': {
                    position: 'relative',
                    top: '-17px'
                },
                '&.done span:before': {
                    opacity: 1,
                    transition: 'opacity 0.3s ease 0.5s',
                },
                '&.volumes-added': {
                    color: '#fff',
                    backgroundColor: brandColors.success.bright,
                    '&:after': {
                        borderLeft: `17px solid ${brandColors.success.bright}`,
                    },
                },
                '&.volumes-not-added': {
                    color: '#fff',
                    backgroundColor: brandColors.error.bright,
                    '&:after': {
                        borderLeft: `17px solid ${brandColors.error.bright}`,
                    },
                },
                '&.allocation-completed': {
                    color: '#fff',
                    backgroundColor: brandColors.success.bright,
                    '&:after': {
                        borderLeft: `17px solid ${brandColors.success.bright}`,
                    },
                },
                '&.allocation-not-started': {
                    color: '#424b5a',
                    backgroundColor: '#c2d1d9',
                    '&:after': {
                        borderLeft: '17px solid #c2d1d9',
                    },
                },
                '&.allocation-started': {
                    color: '#fff',
                    backgroundColor: brandColors.primary.light,
                    '&:after': {
                        borderLeft: `17px solid ${brandColors.primary.light}`,
                    },
                },
                '&.report-submitted': {
                    color: '#fff',
                    backgroundColor: brandColors.success.bright,
                    '&:after': {
                        borderLeft: `17px solid ${brandColors.success.bright}`,
                    },
                },
                '&.report-not-submitted': {
                    color: '#fff',
                    backgroundColor: brandColors.primary.light,
                    '&:after': {
                        borderLeft: `17px solid ${brandColors.primary.light}`,
                    },
                },
                '&.report-not-initiated': {
                    color: '#424b5a',
                    backgroundColor: '#c2d1d9',
                    '&:after': {
                        borderLeft: '17px solid #c2d1d9',
                    },
                },
            },
        },
    });
